export type MayBeMissing = 'may_be_missing'

export type ObjectMap<K extends string | number | symbol, V> =
    Record<K, V> & {[K in MayBeMissing]?: V}

export function createObjectMap<K extends string | number | symbol, V>(): ObjectMap<K, V> {
    return Object.create(null) as ObjectMap<K, V>
}
